import Profile from "../../employee/profile/Profile";

export default Profile;